import styled from 'styled-components'
import { colors } from '../../styles/colors'
import sortingSvg from '../../assets/icons/sorting.svg'
import sortingSvgAsc from '../../assets/icons/sortingAsc.svg'
import sortingSvgDesc from '../../assets/icons/sortingDesc.svg'
import React, { useCallback, useEffect, useRef } from 'react'
import TableLoadingLayer from './TableLoadingLayer'
import { useTableState } from './TableProvider'
import i18n from '../../translation/i18n'

const StyledTableWrapper = styled.div`
  position: relative;

  .table-scroll-helper {
    position: relative;
    top: -85px;
  }
  .react-datepicker-popper {
    z-index: 9999 !important;
  }
  .cursor-pointer{
    cursor:pointer
  }
  .cursor-no-drop{
    cursor:no-drop
  }

  .react-bootstrap-table {
    overflow: auto;
    background: white;
    padding: 1px;
    .table{
      margin-bottom:0;
    }
  }
  .group-member-table {
    overflow: visible !important;

  }

  table {
    color: ${colors.textColorB80};
    word-break:break-word;
  }

//   tr.active, tr.active:hover {
//     background-color: rgba(0,0,0,0.075);
//   }
/* === Uniform row highlight (hover + active) — row AND all cells match === */
& .table {
  --bs-table-hover-bg: ${colors.gray2};
  --bs-table-active-bg: ${colors.gray2};
  --bs-table-hover-color: inherit;
  --bs-table-active-color: inherit;
}

/* HOVER */
& .table-hover tbody tr:hover {
  background-color: var(--bs-table-hover-bg) !important;
}
& .table-hover tbody tr:hover > td,
& .table-hover tbody tr:hover > th {
  background-color: var(--bs-table-hover-bg) !important; /* cells */
  // color: var(--bs-table-hover-color) !important;
}
tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04); /* subtle highlight */
}

tbody tr:hover td,
tbody tr:hover th {
  background-color: transparent; /* don't override cell bg */
  // color: inherit !important;  /* do not override text colors */
}


/* ACTIVE / SELECTED (your .active class and Bootstrap's) */
& tbody tr.active,
& tbody tr.table-active,
& tbody tr.selected {
  background-color: var(--bs-table-active-bg) !important;
}
& tbody tr.active > td,
& tbody tr.active > th,
& tbody tr.table-active > td,
& tbody tr.table-active > th,
& tbody tr.selected > td,
& tbody tr.selected > th {
  background-color: var(--bs-table-active-bg) !important; /* cells */
  color: var(--bs-table-active-color) !important;
}


  tr.is-deleted {
    text-decoration: line-through;
  }

  .table-bordered {
    border: 0;
    td {
      border-left: 0;
      border-right: 0;
      overflow: auto;
    }
  }

  thead {
    box-shadow: 0px 0px 0px 1px #b8b8b8;
    th {
      border:none;
      font-size: 12px;
      text-transform: uppercase;
      padding:  5px 10px 5px 10px;

      .order-4,
      .caret-4-desc,
      .caret-4-asc {
        position: absolute;
        right: 15px;

        &:before {
          content: '';
          display: block;
          height: 14px;
          width: 8px;
          background: url(${encodeURI(sortingSvg)});
          opacity: 1;
        }
        &:after {
        content: none;
        }
      }

      .caret-4-asc {
        &:before {
           background: url(${encodeURI(sortingSvgAsc)}) center center;
        }
      }

      .caret-4-desc {
        &:before {
           background: url(${encodeURI(sortingSvgDesc)}) center center;
        }
      }
      .filter-label {
        margin: 3px 0 0 0;
        display: block;
        position: relative;
        width: 100%;

        input {
          padding-right: 35px;

          &::-ms-clear {
            display: none;
          }
        }

        &:after {
          content: "";
          height: 16px;
          width: 16px;
          display: block;
          position: absolute;
          top: 8px;
          right: 10px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='M505.7 475.6L360.1 330c28.2-34.8 45.2-79.1 45.2-127.3C405.3 90.9 314.4 0 202.7 0S0 90.9 0 202.7s90.9 202.7 202.7 202.7c48.2 0 92.5-17 127.3-45.2l145.6 145.6c4.2 4.2 9.6 6.3 15.1 6.3s10.9-2.1 15.1-6.3c8.3-8.4 8.3-21.9-.1-30.2zm-303-112.9c-88.2 0-160-71.8-160-160s71.8-160 160-160 160 71.8 160 160-71.8 160-160 160z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
        }
      }
    }
  }
  .no-data-placeholder-alert {
    margin-bottom: 28rem;
    @media screen and (max-width:767px){
      display: none;
    }
  }
  .no-data-placeholder {
    margin: 14rem 0;
    font-weight: 600;
    font-size: 1.6rem;
    color: ${colors.textColorSecondary};
    @media screen and (max-width:426px){
      display: none;
    }
  }

  th {
    background: ${colors.gray1};
    position:relative;
    &:after {
      content: "";
      display: block;
      width: 1px;
      height: 87.5%;
      background: ${colors.gray3};
      position: absolute;
      right: 0;
      top: 7.5%;
    }
  
    
    &:last-child {
      &:after {
        display: none;
      }
    }


  }
  
  .pagination {
    justify-content: flex-end;
  }

  .actions-cell svg {
    fill: black;
    width: 20px;
    margin-right: 10px;
    cursor: pointer;

    &.delivery-icon {
      width: 30px;
    }
  }
  .top-header-cell {
    vertical-align: top;
  }
  .middle-header-cell {
    vertical-align: middle;
  }
  .costcenter-cell {
    border-right: 0;
  }
  .actions-header-cell {
    position:relative;
    border-left: 0;
    width: 180px;
  }
  .actions-cell {
    padding: 10px;
    vertical-align: middle;
    > span {
      display: none;
      justify-content: space-evenly; 
    }
  }
  .checkBox-header-cell {
    position:relative;
    border-left: 0;
    width: 100px;
    vertical-align: middle;
    > span {
      display: flex;
      justify-content: space-evenly; 
    }
  }
  .checkBox-cell {
    vertical-align: middle;
    > span {
      display: flex;
      justify-content: space-evenly; 
      align-items: center
    }
  }
  .checkBox-cell svg {
    cursor: pointer;
  }
 
  tbody tr:hover {
    .actions-cell > span {
      display: flex;
    }
  }
  tbody{
    td{
      padding:0.75rem;
    }
  }

  .react-bootstrap-table-pagination {
    margin-top:20px;
    justify-content: center;
    flex-direction: row-reverse;
    > div {
      flex: 0;
      max-width: none;
    }

    .pagination {
      justify-content: flex-start;
      overflow: auto;
    }
  }


  @media (max-width: 1079px) {
    thead > tr > th > span {
      display:none;
    }
    .actions-cell > span {
      display: flex;
    }
    /* Row dividers from 1079px down */
        tbody > tr {
        border-bottom: 1px solid ${colors.gray3};
        }
        tbody > tr:last-child {
        border-bottom: 0;
        }

        /* Prevent double borders from cells */
        tbody > tr > td,
        tbody > tr > th {
        border-bottom: 0 !important;
        }

  }
  
 
  @media (max-width: 767px) {

      .react-bs-table-no-data{display:none}
     
      .table {
        empty-cells: show;
      }
      
      /* Table head to be lines of 2 */
      thead > tr > th{
         width:50%;
         display:inline-block;
         border:.5px solid gray;
         text-align:center;
      }
      .fullWidthMobile{
        width:100%;
        display:inline-block;
     }

      /* Force table to not be like tables anymore */
        tbody, td {
        display: block;
      }

     th{
      &:after {
        display:none;
      }
     }
        
      /* === MOBILE: first cell left, others right (stacked), striped rows, row divider === */
      tbody > tr {
        display: grid;                         /* row becomes a 2-col grid *
        column-gap: 12px;
        row-gap: 2px;
        padding: 4px 0;
        /* single divider between rows */
       
      }
      
      tbody > tr:last-child {
        border-bottom: 0;
      }
      
      /* Zebra striping (subtle) */
      tbody > tr:nth-child(odd)  { background: transparent }
      tbody > tr:nth-child(even) { background: ${colors.gray1} }
   
      /* Cells: compact + no inner borders that would double the divider */
      tbody > tr > td {
        display: block;
        width: auto;
        border: 0;
        padding: 4px 6px;
        line-height: 1.2;
      }
      
      /* First cell: left column, spans the full right stack height */
      tbody > tr > td:nth-of-type(1) {
        grid-column: 1;
        grid-row: 1 / -1;
        text-align: left;
      }
      
      /* All remaining cells: right column, stacked, right-aligned */
      tbody > tr > td:nth-of-type(n + 2) {
        grid-column: 2;
        justify-self: end;
        text-align: right;
      }

      /* make cells transparent so the tr stripe is visible */
        .table > :not(caption) > * > * { 
          background-color: transparent !important;
        }

        /* extra safety: neutralize any td/th backgrounds */
        tbody > tr > td,
        tbody > tr > th {
          background: transparent !important;
        }
  
      /* If you show mobile header labels via td::before, hide them for this layout.
         If you want to KEEP labels, remove the 3 rules below and fix the 'top' typo to 6px. */
      tbody > tr > td::before { display: none }
      
      td {
        /* Behave  like a "row" */
        border: none;
        border-bottom: 1px solid ${colors.gray3};
        empty-cells: show !important;
        position: relative;
        white-space: normal;
        text-align:left;
      }

      td:before {
        /* Now like a table header */
        position: absolute;
        /* Top/left values mimic padding */
        top: 61px;
        left: 6px;
        width: 44%;
        white-space: nowrap;
        text-align:left;
        font-weight: bold;
      }  
      
      .actions-header-cell, .checkBox-header-cell {
        display:none
      }

      .actions-cell {
        width: 100% !important;
      }  
    }
    /* === Uniform row highlight across whole row (hover + active) === */
    & .table {
        --row-hover-bg: ${colors.gray2};
        --row-active-bg: ${colors.gray2};
        --row-hover-color: inherit;
        --row-active-color: inherit;
        }

        /* HOVER (desktop + mobile) */
        & .table-hover tbody tr:hover {
        background-color: var(--row-hover-bg) !important;
        }
        & .table-hover tbody tr:hover > td,
        & .table-hover tbody tr:hover > th,
        & tbody > tr:hover > td,
        & tbody > tr:hover > th {
        background-color: var(--row-hover-bg) !important;
        // color: var(--row-hover-color) !important;
    }

    /* ACTIVE / SELECTED (your .active class, plus Bootstrap's .table-active/.selected) */
        & tbody tr.active,
        & tbody tr.table-active,
        & tbody tr.selected {
        background-color: var(--row-active-bg) !important;
        }
        & tbody tr.active > td,
        & tbody tr.active > th,
        & tbody tr.table-active > td,
        & tbody tr.table-active > th,
        & tbody tr.selected > td,
        & tbody tr.selected > th {
        background-color: var(--row-active-bg) !important;
        color: var(--row-active-color) !important;
    }

    & .react-bootstrap-table .table-hover tbody tr:hover > td,
        & .react-bootstrap-table .table-hover tbody tr:hover > th {
        background-color: var(--row-hover-bg) !important;
}

  }

  ${(props) => {
    if (props.totalPages) {
      return `
      .react-bootstrap-table-pagination-list {
        &:before {
          text-align: center;
          display: block;
          white-space: nowrap;
          content: "${i18n.t('page')} ${props.currentPage} ${i18n.t('of')} ${
        props.totalPages
      }";
        }
      }
      `
    }
  }}`

const SpecialMobileTableWrapper = ({
  children,
  tableIsLoading,
  noAutoscroll,
  currentPage,
  totalPages,
}) => {
  const tableScrollHelperRef = useRef()
  const { tableRef } = useTableState()

  const scrollTableIntoView = useCallback(() => {
    const { top } = tableScrollHelperRef.current.getBoundingClientRect()
    if (top < 0 || top > window.innerHeight) {
      tableScrollHelperRef.current.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      })
    }
  }, [])

  useEffect(() => {
    if (tableIsLoading && !noAutoscroll) {
      scrollTableIntoView()
    }
  }, [tableIsLoading, noAutoscroll, scrollTableIntoView])

  return (
    <>
      <div className='table-scroll-helper' ref={tableScrollHelperRef} />
      <StyledTableWrapper currentPage={currentPage} totalPages={totalPages}>
        {children}
        <TableLoadingLayer
          tableRef={tableRef}
          tableIsLoading={tableIsLoading}
        />
      </StyledTableWrapper>
    </>
  )
}

export default SpecialMobileTableWrapper
